import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  HomeIcon, 
  FolderIcon, 
  DocumentIcon,
  UserGroupIcon, 
  CurrencyDollarIcon, 
  ClockIcon,
  ChartBarIcon,
  ArrowLeftOnRectangleIcon
} from '@heroicons/react/24/outline';
import clsx from 'clsx';

const navigation = [
  { name: 'Dashboard', icon: HomeIcon, path: '/dashboard' },
  { name: 'Projects', icon: FolderIcon, path: '/projects' },
  { name: 'Resources', icon: UserGroupIcon, path: '/resources' },
  { name: 'Clients', icon: UserGroupIcon, path: '/clients' },
  { name: 'Finance', icon: CurrencyDollarIcon, path: '/finance' },
  { name: 'Documents', icon: DocumentIcon, path: '/documents' },
  { name: 'Time', icon: ClockIcon, path: '/time' },
  { name: 'Reports', icon: ChartBarIcon, path: '/reports' },
];

interface SidebarProps {
  isOpen: boolean;
  onLogout: () => void;
}

export function Sidebar({ isOpen, onLogout }: SidebarProps) {
  const location = useLocation();

  return (
    <aside className={clsx(
      'fixed top-0 inset-y-0 left-0 z-20 w-64 bg-gray-950 border-r border-gray-800',
      'transform transition-transform duration-300 ease-in-out lg:translate-x-0',
      isOpen ? 'translate-x-0' : '-translate-x-full'
    )}>
      <nav className="h-full pt-20 pb-4 px-3 flex flex-col">
        <div className="flex-1">
        {navigation.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={clsx(
              'group flex items-center px-3 py-2 my-1 text-sm font-medium rounded-md',
              'text-gray-300 hover:bg-gray-800 hover:text-red-500',
              location.pathname === item.path && 'bg-gray-800 text-red-500'
            )}
          >
            <item.icon className="mr-3 h-6 w-6" />
            {item.name}
          </Link>
        ))}
        </div>
        
        <button
          onClick={onLogout}
          className={clsx(
            'flex items-center px-3 py-2 text-sm font-medium rounded-md w-full',
            'text-gray-300 hover:bg-gray-800 hover:text-red-500'
          )}
        >
          <ArrowLeftOnRectangleIcon className="mr-3 h-6 w-6" />
          Logout
        </button>
      </nav>
    </aside>
  );
}